const postOpItemTypes = {
  new: "new",
  view: "view",
};

export default postOpItemTypes;
